import React, { useState, useRef } from "react";
import Autosuggest from "react-autosuggest";

const SearchByDateNac = ({ filteredDates, value, setValue, inputProps }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const inputRef = useRef();

  // Determinar si el input es de solo lectura a través de las props
  const isReadOnly = inputProps && inputProps.readOnly;

  // Modificado: onSuggestionsFetchRequested solo se ejecuta si NO es readOnly
  const onSuggestionsFetchRequested = ({ value: inputValue }) => {
    if (isReadOnly) {
      setSuggestions([]); // No mostrar sugerencias si es readOnly
      return;
    }
    const filtered = inputValue.trim()
      ? filteredDates.filter((datePart) =>
          datePart.startsWith(inputValue.trim())
        )
      : filteredDates;
    setSuggestions(filtered);
  };

  // Modificado: onFocus solo muestra sugerencias si NO es readOnly
  const onFocus = () => {
    if (!isReadOnly) {
      setSuggestions(filteredDates);
    }
  };

  // onSuggestionsClearRequested no necesita cambios
  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const getSuggestionValue = (suggestion) => suggestion;

  // renderSuggestion no necesita cambios
  const renderSuggestion = (suggestion, { isHighlighted }) => (
    <div
      className={`suggestion-item ${isHighlighted ? "highlighted" : ""}`}
      // Modificado: onClick solo funciona si NO es readOnly
      onClick={() => {
        if (!isReadOnly) {
          setValue(suggestion);
        }
      }}
    >
      {suggestion}
    </div>
  );

  const handleKeyDown = (event) => {
    if (isReadOnly) { // No permitir navegación con teclado si es readOnly
      return;
    }
    if (event.key === "ArrowDown") {
      setHighlightedIndex((prev) =>
        prev < suggestions.length - 1 ? prev + 1 : 0
      );
    } else if (event.key === "ArrowUp") {
      setHighlightedIndex((prev) =>
        prev > 0 ? prev - 1 : suggestions.length - 1
      );
    } else if (event.key === "Enter" && highlightedIndex >= 0) {
      const selectedSuggestion = suggestions[highlightedIndex];
      if (selectedSuggestion) {
        setValue(selectedSuggestion);
        setHighlightedIndex(-1);
      }
    }
  };

  // Modificado: handleChange no permite input directo si es readOnly
  const handleChange = (event, { newValue }) => {
    if (isReadOnly) { // No permitir que el usuario escriba si es readOnly
      return;
    }
    if (/^\d*$/.test(newValue)) {
      setValue(newValue);
    }
  };

  return (
    <div className="suggestion-wrapper">
      <Autosuggest
        // Modificado: Las sugerencias estarán vacías si es readOnly
        suggestions={isReadOnly ? [] : (suggestions.length > 0 ? suggestions : filteredDates)}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        onSuggestionHighlighted={({ suggestionIndex }) => {
          if (!isReadOnly) { // Solo resaltar si no es readOnly
            setHighlightedIndex(suggestionIndex || -1);
          }
        }}
        inputProps={{
          ...inputProps,
          value,
          onChange: handleChange,
          onKeyDown: handleKeyDown,
          ref: inputRef,
          onFocus: onFocus, // Usamos la función onFocus modificada
          pattern: "[0-9]*",
          // readOnly: isReadOnly, // Ya se pasa via ...inputProps
        }}
      />
    </div>
  );
};

export default SearchByDateNac;